var React = require('react');

function IconHeartOutlinedInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.46 1.36a5.2 5.2 0 016.82-.16l.18.16.54.5.54-.5a5.2 5.2 0 016.82-.16l.18.16a4.45 4.45 0 01.16 6.43l-.16.16L9 15 1.46 7.95a4.46 4.46 0 010-6.6zm14.27.52a4.24 4.24 0 00-5.37 0l-.16.15L9 3.14 7.8 2.03a4.23 4.23 0 00-5.69 0 3.54 3.54 0 00-.14 5.11l.14.14L9 13.72l6.89-6.44a3.54 3.54 0 00.14-5.11l-.14-.14-.16-.15z","fill":"currentColor","fillRule":"nonzero"}));
}

IconHeartOutlinedInline.defaultProps = {"width":"18","height":"15"};

module.exports = IconHeartOutlinedInline;

IconHeartOutlinedInline.default = IconHeartOutlinedInline;
